'use client';
//TODO: Complete
import { logError } from '@/app/helpers/azureBlobLogger';
import { useEffect, useState } from 'react';
import Loader from '../Loader/Loader';
import { doUseOrderStorageStore } from '@/stores/order-storage-store';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from 'zustand';
import { iFilterableArea } from '@/app/models/apiModels/filterableArea';
import { set } from 'lodash';
import { eAreaType } from '@/app/models/enum/areaType';
import Area from './Area';

interface Props {
    culture: string;
    orderStep1Url: string;
    translations: any;
}

export default function AllFacilitiesAndSizes({ culture, orderStep1Url, translations }: Props) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [filterableAreas, setFilterableAreas] = useState<iFilterableArea[]>([]);

    //TODO: Lägg till tracking
    const trackingStore = doUseOrderStorageStore(useShallow((state) => state.tracking));
    const setTrackingValue = useStore(
        doUseOrderStorageStore,
        useShallow((state) => state)
    )?.setTrackingValue;

    useEffect(() => {
        const fetchFilterableAreas = async () => {
            try {
                const response = await fetch('/api/size/getAllFacilitiesAndSizes', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'culture': culture
                    }
                });

                if (!response.ok) {
                    setIsLoading(false);
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();

                const filterableAreasResponse = data as iFilterableArea[];

                if (filterableAreasResponse.length === 1 && filterableAreasResponse[0].type === eAreaType.Country && filterableAreasResponse[0].subAreas) {
                    setFilterableAreas(filterableAreasResponse[0].subAreas);
                } else {
                    setFilterableAreas(filterableAreasResponse);
                }
                setIsLoading(false);
            } catch (error) {
                logError("Error in AllFacilitiesAndSizes", 'Error when fetching AllFacilitiesAndSizes', `culture: ${culture}`, 'Error', error);
                setIsLoading(false);
            }
        }

        fetchFilterableAreas();
    }, []);




    return (
        <div>
            {isLoading && (
                <Loader loading={isLoading} useFullWindow={false} useNoBackground={true} />
            )}
            {!isLoading && filterableAreas.length > 0 && (
                <div>
                    {filterableAreas.map((area, index) => (
                        <Area
                            key={index}
                            filterableArea={area}
                            orderStep1Url={orderStep1Url}
                            translations={translations}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}


